import type { ColumnsType } from 'antd/es/table';
import moment from 'moment';

import { renderCycleColumnData } from './helpers';
import type { RecordInTable } from './types';

export const WEEK = ['日', '一', '二', '三', '四', '五', '六'];

export const COLUMNS: ColumnsType<RecordInTable> = [
  {
    title: '路線',
    dataIndex: 'route',
  },
  {
    title: '設備',
    dataIndex: 'equipment',
    render: (_, { equipment }) => equipment.map(({ name }) => name).join(', '),
  },
  {
    title: '巡檢人員',
    dataIndex: 'inspector',
    render: (_, { inspector }) => inspector.map(({ name }) => name).join(', '),
  },
  {
    title: '期間',
    dataIndex: 'period',
    render: (_, { period: { start, end } }) => {
      const startDate = moment(start).format('YYYY/MM/DD');
      const endDate = moment(end).format('YYYY/MM/DD');
      return `${startDate}~${endDate}`;
    },
  },
  {
    title: '週期',
    dataIndex: 'cycle',
    render: renderCycleColumnData,
  },
  {
    title: '時間',
    dataIndex: 'slot',
    render: (_, { slot }) => slot.join(', '),
  },
];

export const CYCLE_TYPE_OPTIONS = [
  {
    label: '每月',
    value: 'month',
  },
  {
    label: '每週',
    value: 'week',
  },
];

export const FORM_INITIAL_VALUES = {
  cycle: { type: CYCLE_TYPE_OPTIONS[0].value },
  slot: [[moment('09:00', 'HH:mm'), moment('13:00', 'HH:mm')]],
};

export const DEFAULT_OPTION = {
  label: '全部',
  value: '全部',
};
